import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router";
import apiCall from "../../../components/Api";
import NextBackBtns from "../../../components/Common/nextBackBtns";
import {
  action,
  // Medicine_Status,
  prescriptionType,
  returnable,
  stock,
  yesOrNo,
} from "../../../components/Constants";
import SucessModal from "../../../components/Modal/SucessModal";
import Level from "./medicineFormStepHeaderTab";
import StepOne from "./medicineFormStepOne";
import StepTwo from "./medicineFormStepTwo";

const MedicineForm = ({ edit = false }) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const {
    register,
    setValue,
    getValues,
    watch,
    control,
    formState: { errors },
    handleSubmit,
    trigger,
  } = useForm();

  const [success, setSuccess] = useState(false);
  const [description, setDescription] = useState("");
  const [authorDetail, setAuthorDetail] = useState("");
  const [warning, setWarning] = useState("");
  const [direction, setDirection] = useState("");
  const [sideEffect, setSideEffect] = useState("");
  const [storage, setStorage] = useState("");
  const [dosage, setDosage] = useState("");
  const [reference, setReference] = useState("");
  const [fileList, setFileList] = useState([]);
  const [manufacturerList, setManufacturerList] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [saltList, setSaltList] = useState([]);
  const [medicineTypes, setMedicineTypes] = useState([]);
  const [variants, setVariants] = useState([]);
  const [faqs, setFaqs] = useState([]);

  const getMedicineDetails = useCallback(async () => {
    try {
      const result = await apiCall(`medicine/get/${id}`, "GET");
      if (result.data) {
        const data = result.data;
        setValue("medicine_name", data.medicine_name);
        setValue("package_description", data.package_description);
        setValue("product_id", data.product_id);
        setValue("mrp", data.mrp);
        setValue("discount", data.discount);
        setValue("quantity", data.quantity);
        setValue("mrp_per_unit", data.mrp_per_unit);
        setValue("unit", data.unit);
        setValue("medicine_type", data.medicine_type);
        setValue("medicine_status", data.medicine_status);
        setValue("stock", data.stock === true ? stock[0] : stock[1]);
        setValue(
          "prescription_type",
          data.prescription_type === true
            ? prescriptionType[0]
            : prescriptionType[1],
        );
        setValue(
          "medicine_url_status",
          data.medicine_url_status === true ? action[0] : action[1],
        );
        setValue("manufacturer", {
          ...data.manufacturer_name,
          label: data.manufacturer_name.manufacturer_name,
          value: data.manufacturer_name.manufacturer_name,
          id: data.manufacturer_name._id,
        });
        setValue(
          "returnable",
          data.returnable === true ? returnable[0] : returnable[1],
        );
        setValue("open_box", data.open_box === true ? yesOrNo[0] : yesOrNo[1]);
        setValue("salt_molecule", {
          ...data.salt_molecule,
          value: data.salt_molecule._id,
          label: data.salt_molecule.molecule_name,
        });
        setValue("therapeutic_uses", data.therapeutic_uses);
        setValue("description", data.description);
        setValue("author_details", data.author_details);
        setValue("warning_precaution", data.warning_precaution);
        setValue("direction_uses", data.direction_uses);
        setValue("side_effects", data.side_effects);
        setValue("storage_disposal", data.storage_disposal);
        setValue("dosage", data.dosage);
        setValue("reference", data.reference);
        setDescription(`${data.description}`);
        setAuthorDetail(`${data.author_details}`);
        setWarning(`${data.warning_precaution}`);
        setDirection(`${data.direction_uses}`);
        setSideEffect(`${data.side_effects}`);
        setStorage(`${data.storage_disposal}`);
        setDosage(`${data.dosage}`);
        setReference(`${data.reference}`);
        // data.faq
        setFaqs(
          data.faq.map((data, inx) => {
            setTimeout(() => {
              setValue(`question-${inx + 1}`, data.question);
            }, 200);
            setValue(`answer-${inx + 1}`, data.answer);
            return {
              id: inx + 1,
              question: data.question,
              answer: data.answer,
            };
          }),
        );
        if (data?.variants?.length) {
          setVariants(
            data.variants.map((variant, inx) => {
              setValue(
                `package_description-${inx + 1}`,
                variant.package_description,
              );
              setValue(`mrp-${inx + 1}`, variant.mrp);
              setValue(`discount-${inx + 1}`, variant.discount);
              setValue(`quantity-${inx + 1}`, variant.quantity);
              setValue(`mrp_per_unit-${inx + 1}`, variant.mrp_per_unit);
              setValue(`unit-${inx + 1}`, variant.unit);
              setValue(
                `stock-${inx + 1}`,
                variant.stock === true ? stock[0] : stock[1],
              );
              setValue(
                `prescription_type-${inx + 1}`,
                variant.prescription_type === true
                  ? prescriptionType[0]
                  : prescriptionType[1],
              );
              setValue(
                `medicine_status-${inx + 1}`,
                variant.medicine_status === true ? action[0] : action[1],
              );
              setValue(
                `returnable-${inx + 1}`,
                variant.returnable === true ? returnable[0] : returnable[1],
              );
              setValue(
                `open_box-${inx + 1}`,
                variant.open_box === true ? yesOrNo[0] : yesOrNo[1],
              );
              return {
                title: `Variant ${inx + 1}`,
                id: inx + 1,
                images: variant.photos.map((file, inx) => {
                  return typeof file === "string"
                    ? { uid: `server-${inx}`, url: file }
                    : file;
                }),
              };
            }),
          );
        }
        setFileList(
          data.photos.map((file, index) =>
            typeof file === "string"
              ? { uid: `server-${index}`, url: file }
              : file,
          ),
        );
      }
    } catch (err) {
      console.error(err);
    }
  }, [id, setValue]);
  useEffect(() => {
    if (edit) {
      getMedicineDetails(id);
    }
  }, [id, edit, getMedicineDetails]);

  useEffect(() => {
    if (getValues("manufacturer")) {
      setValue("manufacturer", getValues("manufacturer"));
    }
  }, [manufacturerList, setValue, getValues]);

  useEffect(() => {
    if (getValues("manufacturer")) {
      setValue("manufacturer", getValues("manufacturer"));
    }
  }, [manufacturerList, setValue, getValues]);

  const getManufacturerList = async () => {
    try {
      const response = await apiCall(`manufacturer/list`, "POST", {
        active: true,
      });
      setManufacturerList(
        response.data?.records?.map((data) => ({
          value: data.manufacturer_name,
          label: data.manufacturer_name,
          id: data._id,
          ...data,
        })),
      );
    } catch (err) {
      console.error(err);
      alert("Some error");
    }
  };

  const getUnitList = async () => {
    try {
      const response = await apiCall(`unit/list`, "POST", {
        active: true,
      });
      setUnitList(
        response.data?.records?.map((data) => ({
          value: data._id,
          label: data.unit,
        })),
      );
    } catch (err) {
      console.error(err);
      alert("Some error");
    }
  };

  const getMedicineTypes = async () => {
    try {
      const response = await apiCall(`product-type/list`, "POST", {
        active: true,
      });
      setMedicineTypes(
        response.data?.records?.map((data) => ({
          value: data._id,
          label: data.product_type_name,
          id: data._id,
        })),
      );
    } catch (err) {
      console.error(err);
      alert("Some error");
    }
  };

  const getSaltList = async () => {
    try {
      const response = await apiCall(`salt-molecule/list`, "POST", {
        active: true,
      });
      setSaltList(
        response.data?.records?.map((data) => ({
          value: data._id,
          label: data.molecule_name,
          therapeutic_classification: data.therapeutic_classification,
        })),
      );
    } catch (err) {
      console.error(err);
      alert("Some error");
    }
  };

  useEffect(() => {
    getManufacturerList();
    getUnitList();
    getSaltList();
    getMedicineTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  // 	edit && getMenuData();
  // }, [edit]);

  const onSubmit = async (fields) => {
    const formValues = getValues();
    const formData = new FormData();

    const tempVariants = variants.map((data, inx) => {
      data.images.forEach((file) => {
        if (file.url) {
          formData.append(`img_variant_${inx}`, file?.url);
        } else {
          formData.append(`img_variant_${inx}`, file?.originFileObj);
        }
      });
      return {
        // photos: variants?.photos,
        mrp: formValues[`mrp-${[data.id]}`],
        discount: formValues[`discount-${[data.id]}`],
        quantity: formValues[`quantity-${[data.id]}`],
        mrp_per_unit: formValues[`mrp_per_unit-${[data.id]}`],
        unit: formValues[`unit-${[data.id]}`],
        package_description: formValues[`package_description-${[data.id]}`],
        stock: formValues[`stock-${[data.id]}`] === "Available",
        prescription_type:
          formValues[`prescription_type-${[data.id]}`] === "Rx",
        medicine_url_status:
          formValues[`medicine_url_status-${[data.id]}`] === "Active",
        returnable: formValues[`returnable-${[data.id]}`] === "Returnable",
        open_box: formValues[`open_box-${[data.id]}`] === "Yes",
        medicine_status: formData[`medicine_status-${[data.id]}`],
      };
    });

    const updatedValues = {
      medicine_name: formValues.medicine_name,
      package_description: formValues.package_description,
      product_id: formValues.product_id,
      medicine_type: formValues.medicine_type,
      mrp: formValues.mrp,
      discount: formValues.discount,
      quantity: formValues.quantity,
      mrp_per_unit: formValues.mrp_per_unit,
      unit: formValues.unit,
      variants: tempVariants,
      stock: formValues.stock === "Available",
      prescription_type: formValues.prescription_type === "Rx",
      medicine_url_status: formValues.medicine_url_status === "Active",
      medicine_status: formValues.medicine_status,
      manufacturer_name: formValues.manufacturer._id,
      returnable: formValues.returnable === "Returnable",
      open_box: formValues.open_box === "Yes",
      salt_molecule: formValues.salt_molecule?.value,
      therapeutic_uses: formValues.therapeutic_uses,
      description: formValues.description,
      author_details: formValues.authorDetail,
      warning_precaution: formValues.warning,
      direction_uses: formValues.direction,
      side_effects: formValues.sideEffect,
      storage_disposal: formValues.storage,
      dosage: formValues.dosage,
      reference: formValues.reference,
      faq: faqs.map((data) => ({
        question: formValues?.[`question-${data.id}`],
        answer: formValues?.[`answer-${data.id}`],
      })),
    };

    fileList.forEach((file) => {
      if (file.url) {
        formData.append("photos", file?.url);
      } else {
        formData.append("photos", file?.originFileObj);
      }
    });

    Object.keys(updatedValues).forEach((key) => {
      const value = updatedValues[key];

      if (Array.isArray(value) || typeof value === "object") {
        formData.append(key, JSON.stringify(value)); // Convert objects/arrays to JSON string
      } else {
        formData.append(key, value);
      }
    });
    let result;
    if (edit) {
      result = await apiCall(`medicine/update/${id}`, "POST", formData);
    } else {
      result = await apiCall(`medicine/create`, "POST", formData);
    }

    if (result?.data?._id) {
      setSuccess(true);
    } else {
      alert("Fail");
      console.log("failed...");
    }
  };

  const handleNext = async () => {
    await trigger();
    if (!Object.keys(errors)?.length) {
      // if (!Object.keys(errors)?.length && fileList?.length) {
      setStep(2);
    }
  };
  const handleBack = () => {
    setStep(1);
  };
  return (
    <>
      <Level page={step} edit={edit} />
      <div className="medicineFormWrapper mt-2">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="career-jobpost-form clinicProfile mt-2 ms-2"
        >
          {step === 1 ? (
            <StepOne
              register={register}
              errors={errors}
              setValue={setValue}
              getValues={getValues}
              watch={watch}
              control={control}
              trigger={trigger}
              setStep={setStep}
              fileList={fileList}
              setFileList={setFileList}
              manufacturerList={manufacturerList}
              unitList={unitList}
              saltList={saltList}
              medicineTypes={medicineTypes}
              variants={variants}
              setVariants={setVariants}
              // medicine_status={Medicine_Status}
            />
          ) : (
            ""
          )}
          {step === 2 ? (
            <StepTwo
              register={register}
              errors={errors}
              setValue={setValue}
              watch={watch}
              setStep={setStep}
              description={description}
              setDescription={setDescription}
              authorDetail={authorDetail}
              setAuthorDetail={setAuthorDetail}
              warning={warning}
              setWarning={setWarning}
              direction={direction}
              setDirection={setDirection}
              sideEffect={sideEffect}
              setSideEffect={setSideEffect}
              storage={storage}
              setStorage={setStorage}
              dosage={dosage}
              setDosage={setDosage}
              reference={reference}
              setReference={setReference}
              faqs={faqs}
              setFaqs={setFaqs}
            />
          ) : (
            ""
          )}
          <div className="d-flex justify-content-center mb-5">
            {step === 1 ? (
              <NextBackBtns back={false} handleNext={handleNext} />
            ) : (
              <NextBackBtns
                next={false}
                submitBtn={true}
                handleBack={handleBack}
              />
            )}
          </div>
          {/* {step === 2 ? (
						<>
						</>
					) : (
						<div className="car-dep-form-button mt-0">
							<button type="submit" style={{ marginTop: "5%" }}>
								SUBMIT
							</button>
						</div>
					)} */}
        </form>
      </div>
      {success && (
        <SucessModal
          onClick={() =>
            navigate("/healthsy-services/order-medicines/medicine-details")
          }
          name={`${edit ? "" : "new"} Medicine`}
          post={edit ? "updated" : "added"}
        />
      )}
    </>
  );
};

export default MedicineForm;
